export const IS_VALUES_READY_NAME = "IS_VALUES_READY";
